/**
 * Ruft die Event-Daten ab, optional mit UserToken, wenn der Nutzer angemeldet ist.
 *
 * @param {string} eventId - Die Event-ID, die abgerufen werden soll.
 * @param {string} apiBaseUrl - Die Basis-URL der Eventive-API.
 * @param {string} privatApiKey - Der private API-Schlüssel für die Authentifizierung.
 * @param {string} [userToken=''] - Optionaler UserToken, wenn der Benutzer angemeldet ist.
 * @returns {Promise<EventiveEvent>} - Ein Promise, das die Event-Daten als JSON zurückgibt.
 */
export function fetchEventData(eventId, apiBaseUrl, privatApiKey, userToken = '') {
  const url = `${apiBaseUrl}/events/${eventId}` + (userToken ? `?token=${userToken}` : '');
  return fetch(url, {
    method: 'GET',
    headers: {
      'Authorization': `Basic ${btoa(privatApiKey)}`,  // Basis-Authentifizierung mit API-Schlüssel
      'Content-Type': 'application/json',
    },
  }).then(response => response.json());
}
